import type { FaireProductEntity } from "../../entity_types/product";

export const p_k2qcdx9n9e: FaireProductEntity = {
  token: "p_k2qcdx9n9e",
  type: "product",
  name: "Green Bandana Fringe Crossbody",
  brandToken: "b_5m4wqw135i",
  brandName: "Panache Apparel Co.",
  imageUrl: "https://cdn.faire.com/fastly/051f4db64b1f03aae26c0a76b5f386acb2bf33dcdf107267016ac98d216aaadd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9ccfe9b32c8e1791a8c17af7153daa22b200df13e3367cb76acb382a6161c1d0.jpeg",
    "https://cdn.faire.com/fastly/eca46125d70aa4da6a4e7d8358d863da7e3609bbf8f3e8302f4703b28654131f.jpeg"
  ],
  priceDollars: 37.95,
  description: "A green bandana fringe crossbody featuring a classic paisley print, designed with a long crossbody strap and suede leather fringe detailing for a stylish western-inspired look. Roomy interior is perfect for carrying daily essentials while adding a statement touch to any outfit.\n\n14\" W x 10\" H\n\n100% Cotton\n\nMin. Qty: 2",
  tags: [],
  msrpDollars: 94.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:05:44.840Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
